import state from './moduleQurbanState.js'
import mutations from './moduleQurbanMutations.js'
import actions from './moduleQurbanActions.js'
import getters from './moduleQurbanGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
